"use client";

import { Link } from "@/components/common/Link";
import { Facebook, Instagram, Twitter } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <footer id="footer" ref={ref} className={`w-full bg-primary-dark text-foreground-dark py-12 transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          {}
          <div className="flex items-center justify-center md:justify-start">
            <p className="text-sm text-muted">
              © {new Date().getFullYear()} Jordan Ebner. All rights reserved.
            </p>
          </div>

          {}
          <nav className="flex flex-col items-center gap-3">
            <Link to="/HomePage" className="text-foreground-dark text-sm font-medium relative inline-block group">
              <span className="relative z-10">Home</span>
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
            </Link>
            <Link to="/PricingPage" className="text-foreground-dark text-sm font-medium relative inline-block group">
              <span className="relative z-10">Pricing</span>
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
            </Link>
            <Link to="/SoundAndLightingPage" className="text-foreground-dark text-sm font-medium relative inline-block group">
              <span className="relative z-10">Sound and Lighting</span>
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
            </Link>
            <Link to="/LetsTalkPage" className="text-foreground-dark text-sm font-medium relative inline-block group">
              <span className="relative z-10">Let's Talk</span>
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
            </Link>
            <Link to="#" className="text-foreground-dark text-sm font-medium relative inline-block group">
              <span className="relative z-10">Contact</span>
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
            </Link>
          </nav>

          {}
          <div className="flex items-center justify-center md:justify-end gap-4">
            <Link to="https://facebook.com" newTab aria-label="Facebook" className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-medium)] hover:scale-110">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://instagram.com" newTab aria-label="Instagram" className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-medium)] hover:scale-110">
              <Instagram className="size-5" />
            </Link>
            <Link to="https://twitter.com" newTab aria-label="Twitter" className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-medium)] hover:scale-110">
              <Twitter className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}